export default function getCsrftoken() {
  const csrftoken = document.cookie.split(';').map(e=>e.trim().match(/^csrftoken=(.*)$/)).filter(e=>e);
  if (csrftoken.length !== 1) {
    return undefined;
  }
  return csrftoken[0][1];
}
